var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-table',{attrs:{"date":_vm.date,"selected-day":_vm.realSelectedDay,"first-day-of-week":_vm.realFirstDayOfWeek},on:{"pick":_vm.pickDay}})}
var staticRenderFns = []

export { render, staticRenderFns }